// @flow
import React, { useMemo } from "react";
import PropTypes from "prop-types";

import Input from "./styledInput";
import useOTP from "./useOTP";

const OtpInput = ({
  OTPLength,
  disabled,
  autoFocus,
  value,
  onChange,
  secure,
  className,
  inputClassName,
  inputStyles,
  style,
  errorMsg,
}) => {
  const {
    activeInput,
    getOtpValue,
    handleOnChange,
    handleOnKeyDown,
    handelOnInput,
    handleOnPaste,
    onInputFocus,
  } = useOTP({
    autoFocus,
    value,
    onChange,
    OTPLength,
  });

  // Needs to be memorized
  const renderInputs = useMemo(() => {
    const otp = getOtpValue();
    const inputs = [];

    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < OTPLength; index++) {
      inputs.push(
        <Input
          className={inputClassName}
          inputStyles={inputStyles}
          key={index}
          focus={activeInput === index}
          value={otp[index]}
          onChange={handleOnChange}
          onKeyDown={handleOnKeyDown}
          onInput={handelOnInput}
          onPaste={handleOnPaste}
          onInputFocus={onInputFocus}
          index={index}
          // onBlur={() => setActiveInput(-1)}
          disabled={disabled}
          autoFocus={autoFocus}
          secure={secure}
          data-testid={`login-mfa-code-${index + 1}-txt`}
        />
      );
    }

    return inputs;
  }, [
    getOtpValue,
    OTPLength,
    inputClassName,
    inputStyles,
    activeInput,
    handleOnChange,
    handleOnKeyDown,
    handelOnInput,
    handleOnPaste,
    onInputFocus,
    disabled,
    autoFocus,
    secure,
  ]);

  return (
    <div>
      <div
        style={{ display: "flex", ...style }}
        className={`${className}`}
        data-testid="otp-input-root"
      >
        {renderInputs}
      </div>
      {errorMsg && (
        <span
          data-testid="login-mfa-verify-code-lbl"
          className="oui-text-danger oui-small"
        >
          {errorMsg}
        </span>
      )}
    </div>
  );
};

// const ErrorSpan = styled.span`
//   font-size: 10px;
//   color: #dc3545;
// `;

OtpInput.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  OTPLength: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  secure: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputStyles: PropTypes.object,
  style: PropTypes.object,
  errorMsg: PropTypes.oneOfType([PropTypes.string]),
};

OtpInput.defaultProps = {
  className: "",
  inputClassName: "",
  OTPLength: 6,
  disabled: false,
  secure: false,
  autoFocus: false,
  value: "",
  inputStyles: {},
  style: {},
};

export default OtpInput;
